"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightDelayNotifyingSettings = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Field_1 = require("../../Form/Field");
const NotifyingSettings_1 = require("../../NotifyingSettings");
require("./index.scss");
const className = 'flight-delay-notifying-settings';
class FlightDelayNotifyingSettings extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.handleNotifyingChange = (data) => {
            this.props.onChange({ ...this.props.notifying, ...data });
        };
        this.handleFormInputChange = (event) => {
            const { name, value } = event.target;
            if (name === 'minutes' && !/^[\d]*$/.test(value)) {
                return;
            }
            this.props.onChange({ ...this.props.notifying, [name]: value });
        };
    }
    render() {
        const { minutes, ...notifying } = this.props.notifying;
        return (react_1.default.createElement("div", { className: className },
            react_1.default.createElement(NotifyingSettings_1.NotifyingSettings, { notifying: notifying, onChange: this.handleNotifyingChange }),
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement(Field_1.FormField, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/DelayNotifyingSettings:Delay', defaultMessage: 'Delay' }), name: 'minutes', onChange: this.handleFormInputChange, value: minutes || '', addon: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/DelayNotifyingSettings:Minutes', defaultMessage: 'min' }) })))));
    }
}
exports.FlightDelayNotifyingSettings = FlightDelayNotifyingSettings;
FlightDelayNotifyingSettings.defaultProps = {
    onChange: () => { },
};
//# sourceMappingURL=index.js.map